import { CHANNEL_VIDEO_LIST_VALUES } from '@wix/wix-vod-shared/src/app-settings/constants/channel-video-list-values';

export function isExpandOnClick(status) {
  return status === CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK;
}

export function isAlwaysShow(status) {
  return status === CHANNEL_VIDEO_LIST_VALUES.ALWAYS_SHOW;
}

export function isNeverShow(status) {
  return Number(status) === CHANNEL_VIDEO_LIST_VALUES.NEVER_SHOW;
}



// WEBPACK FOOTER //
// ./src/widget/utils/video-list.js